// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"f529adb3","685":"85b54574","778":"f96e26bb","956":"db3858d8"}[chunkId] + ".chunk.css";
};